const PERMISSION_KEY= "community:course_review";
const PAGE_URL = {
    COURSE_REVIEW_PAGE: "/admin/community/course-review"
}

export {PERMISSION_KEY, PAGE_URL}

